export default __webpack_public_path__ + "static/media/icon-back-gray.b8601573.svg";